"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  send: function send(data) {
    return request.post('subscriptions/send', data);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsInJlcXVlc3QiLCJwb3N0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMtY2xpZW50L21vZHVsZXMvU3Vic2NyaXB0aW9uL1N1YnNjcmlwdGlvbkFjdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICAgIHNlbmQ6IChkYXRhKSA9PiByZXF1ZXN0LnBvc3QoJ3N1YnNjcmlwdGlvbnMvc2VuZCcsIGRhdGEpLFxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7b0NBQWU7RUFDWEEsSUFBSSxFQUFFLFNBQU5BLElBQUlBLENBQUdDLElBQUk7SUFBQSxPQUFLQyxPQUFPLENBQUNDLElBQUksQ0FBQyxvQkFBb0IsRUFBRUYsSUFBSSxDQUFDO0VBQUE7QUFDNUQsQ0FBQyIsImlnbm9yZUxpc3QiOltdfQ==